import _classPrivateFieldLooseBase from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseBase.js";
import _classPrivateFieldLooseKey from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseKey.js";
var _gcTimeout;
// src/removable.ts
import { timeoutManager } from "./timeoutManager.js";
import { isServer, isValidTimeout } from "./utils.js";
var Removable = (_gcTimeout = /*#__PURE__*/_classPrivateFieldLooseKey("gcTimeout"), class Removable {
  constructor() {
    Object.defineProperty(this, _gcTimeout, {
      writable: true,
      value: void 0
    });
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout();
    if (isValidTimeout(this.gcTime)) {
      _classPrivateFieldLooseBase(this, _gcTimeout)[_gcTimeout] = timeoutManager.setTimeout(() => {
        this.optionalRemove();
      }, this.gcTime);
    }
  }
  updateGcTime(newGcTime) {
    this.gcTime = Math.max(this.gcTime || 0, newGcTime !== null && newGcTime !== void 0 ? newGcTime : isServer ? Infinity : 5 * 60 * 1e3);
  }
  clearGcTimeout() {
    if (_classPrivateFieldLooseBase(this, _gcTimeout)[_gcTimeout]) {
      timeoutManager.clearTimeout(_classPrivateFieldLooseBase(this, _gcTimeout)[_gcTimeout]);
      _classPrivateFieldLooseBase(this, _gcTimeout)[_gcTimeout] = void 0;
    }
  }
});
export { Removable };